import { FaGlobe, FaLock, FaDatabase, FaNetworkWired, FaCode, FaSlidersH } from 'react-icons/fa';
export const ENUM_TABS_SERVICES = {
  GENERAL: 'GENERAL',
  AUTH: 'AUTH',
  SCHEMAS: 'SCHEMAS',
};

export const TABS_SERVICES = [
  { id: 'Parámetros de Red y Protocolo', icon: <FaGlobe />, enum: ENUM_TABS_SERVICES.GENERAL },
  { id: 'Autenticación y Seguridad', icon: <FaLock />, enum: ENUM_TABS_SERVICES.AUTH },
  { id: 'Esquemas y Payloads', icon: <FaDatabase />, enum: ENUM_TABS_SERVICES.SCHEMAS },
];
export const SELECT_ESTATUS_SERVICE = [
  {
    key: 'Conectado',
    value: 'CONECTADO',
  },
  {
    key: 'Mantenimiento',
    value: 'MANTENIMIENTO',
  },
  {
    key: 'Desconectado',
    value: 'DESCONECTADO',
  },
  
];
export const SELECT_ESTATUS_SERVICE_OPT = [
  {
    key: 'Conectado',
    value: 'CONECTADO',
  },
  {
    key: 'Mantenimiento',
    value: 'MANTENIMIENTO',
  },
  {
    key: 'Desconectado',
    value: 'DESCONECTADO',
  },
  //agregamos estas opciones mientras back libera las opciones en ingles
  {
    key: 'CONECTADO',
    value: 'CONECTADO',
  },
  {
    key: 'MANTENIMIENTO',
    value: 'MANTENIMIENTO',
  },
  {
    key: 'DESCONECTADO',
    value: 'DESCONECTADO',
  },
];
export const ENUM_STATUS_SERVICE = {
  CONNECTED: 'CONECTADO',
  MAINTENANCE: 'MANTENIMIENTO',
  DISCONNECTED: 'DESCONECTADO',
};
export const ARRAY_STATUS_SERVICE = [
  ENUM_STATUS_SERVICE.CONNECTED,
  ENUM_STATUS_SERVICE.MAINTENANCE,
  ENUM_STATUS_SERVICE.DISCONNECTED,
];
export const ENUM_METHOD_SERVICE = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
};
export const ARRAY_METHOD_SERVICE = [
  ENUM_METHOD_SERVICE.POST,
  ENUM_METHOD_SERVICE.GET,
  ENUM_METHOD_SERVICE.PUT,
];

export const ENUM_PROTOCOL_TYPE_SERVICE = {
  REST: 'REST',
  SOAP: 'SOAP',
  JDBC: 'JDBC',
  MOCK: 'MOCK',
};
export const ARRAY_PROTOCOL_TYPE_SERVICE = [
  ENUM_PROTOCOL_TYPE_SERVICE.REST,
  ENUM_PROTOCOL_TYPE_SERVICE.SOAP,
  ENUM_PROTOCOL_TYPE_SERVICE.JDBC,
  ENUM_PROTOCOL_TYPE_SERVICE.MOCK,
];
export const ENUM_AUTH_TYPE = {
  NONE: 'NONE',
  BEARER: 'BEARER',
  API_KEY_HEADER: 'API_KEY_HEADER',
  API_KEY_QUERY: 'API_KEY_QUERY',
  BASIC: 'BASIC',
};
export const ARRAY_AUTH_TYPE = [
  ENUM_AUTH_TYPE.NONE,
  ENUM_AUTH_TYPE.BEARER,
  ENUM_AUTH_TYPE.API_KEY_HEADER,
  ENUM_AUTH_TYPE.API_KEY_QUERY,
  ENUM_AUTH_TYPE.BASIC,
];

export const SELECT_PROTOCOL_TYPE = [
  {
    value: 'Elige un protocolo',
    key: '',
  },
  {
    value: 'REST (JSON / HTTP)',
    key: ENUM_PROTOCOL_TYPE_SERVICE.REST,
  },
  {
    value: 'SOAP (XML / WSDL',
    key: ENUM_PROTOCOL_TYPE_SERVICE.SOAP,
  },
  {
    value: 'Base de Datos / JDBC',
    key: ENUM_PROTOCOL_TYPE_SERVICE.JDBC,
  },
  {
    value: 'Simulador / Adaptador Mock',
    key: ENUM_PROTOCOL_TYPE_SERVICE.MOCK,
  },
];

export const SELECT_METHOD_SERVICE = [
  {
    value: 'Elige un método',
    key: '',
  },
  {
    value: 'POST',
    key: ENUM_METHOD_SERVICE.POST,
  },
  {
    value: 'GET',
    key: ENUM_METHOD_SERVICE.GET,
  },
  {
    value: 'PUT',
    key: ENUM_METHOD_SERVICE.PUT,
  },
];

export const ENUM_TABS_API_DETAILS = {
  CONNECTION: 'CONNECTION',
  RESPONSE: 'RESPONSE',
  FIELDS: 'FIELDS',
};
export const TABS_API_DETAILS = [
  { id: 'Probar Conexión', icon: <FaNetworkWired />, enum: ENUM_TABS_API_DETAILS.CONNECTION },
  { id: 'Respuesta de la Colección', icon: <FaCode />, enum: ENUM_TABS_API_DETAILS.RESPONSE },
  { id: 'Campos & Filtro para XSD', icon: <FaSlidersH />, enum: ENUM_TABS_API_DETAILS.FIELDS },
];
export const XSD_TYPES = [
  { key: 'string', value: 'Texto (xs:string)' },
  { key: 'date', value: 'Fecha (xs:date)' },
  { key: 'dateTime', value: 'Fecha y Hora (xs:dateTime)' },
  { key: 'integer', value: 'Entero (xs:integer)' },
  { key: 'decimal', value: 'Decimal (xs:decimal)' },
  { key: 'boolean', value: 'Booleano (xs:boolean)' },
];
